module.exports={
    "NavBar": {
        "hideNavbar": false,
        "colorClass": "is-dark",
        "location": "bottom",
        "Brand": {
            "id": "HeadlightPanels-NavBar-Brand",
            "name": "Approval Actions",
            "displayName": "Draft",
            "hideIcon": null,
            "iconClass": "fa-pencil has-text-text-75",
            "buttonClass": "is-dark is-ghost has-text-white",
            "wrapperClass": "has-background-grey",
            "onclick": "_Pict.views.HeadlightPanels.handlePanelToggle('Status')"
        },
        "Buttons": [
            {
                "id": "HeadlightPanels-NavBar-CurrentSamples-Button",
                "name": "Current Samples",
                "displayName": null,
                "hideIcon": null,
                "iconClass": "fa-qrcode",
                "buttonClass": "is-dark",
                "wrapperClass": "is-hidden",
                "onclick": "_Pict.views.HeadlightPaneSamples.openCurrentSamplesTab(event)"
            },
            {
                "id": "HeadlightPanels-NavBar-Solver-Button",
                "name": "Solver Logs",
                "displayName": null,
                "hideIcon": null,
                "iconClass": "fa-calculator",
                "buttonClass": "is-dark",
                "wrapperClass": null,
                "onclick": "_Pict.views.HeadlightPanels.handlePanelToggle('Solver')"
            },
            {
                "id": "HeadlightPanels-NavBar-Validations-Button",
                "name": "Validation Logs",
                "displayName": null,
                "hideIcon": null,
                "iconClass": "fa-exclamation-triangle",
                "buttonClass": "is-dark",
                "wrapperClass": null,
                "onclick": "_Pict.views.HeadlightPanels.handlePanelToggle('Validations')"
            },
            {
                "id": "HeadlightPanels-NavBar-Download-Button",
                "name": "Download",
                "displayName": null,
                "hideIcon": null,
                "iconClass": "fa-download",
                "buttonClass": "is-dark",
                "wrapperClass": null,
                "onclick": "_Pict.views.HeadlightPaneNavigation.toggleDownloadDropdown(event)"
            },
            {
                "id": "HeadlightPanels-NavBar-FullScreen-Button",
                "name": "screenResize",
                "displayName": null,
                "hideIcon": null,
                "iconClass": "fa-up-right-and-down-left-from-center",
                "buttonClass": "is-dark",
                "wrapperClass": "is-hidden-mobile is-hidden-tablet-only",
                "onclick": "_Pict.providers.DocumentProvider.handleScreenResize()"
            },
            {
                "id": "HeadlightPanels-NavBar-Save-Button",
                "name": "save",
                "displayName": "Save",
                "hideIcon": null,
                "iconClass": "fa-save",
                "buttonClass": "is-dark",
                "wrapperClass": null,
                "showAutoSaveStatus": true,
                "onclick": "_Pict.providers.DocumentProvider.handleSave()"
            },
            {
                "id": "HeadlightPanels-NavBar-Actions-Button",
                "name": "actions",
                "displayName": null,
                "hideIcon": null,
                "iconClass": "fa-bars",
                "buttonClass": "is-dark",
                "wrapperClass": null,
                "onclick": "_Pict.views.HeadlightPanels.handlePanelToggle('Navigation')"
            }
        ]
    },
    "NavigationList": [],
    "PanelList": [
        {
            "location": "right",
            "name": "navigation",
            "displayName": "Actions",
            "iconClass": "fa-check-list",
            "view": "HeadlightPaneNavigation"
        },
        {
            "location": "right",
            "name": "settings",
            "displayName": "Settings",
            "iconClass": "fa-cog",
            "view": "HeadlightPaneSettings",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('Settings', 'open')"
        },
        {
            "location": "left",
            "name": "status",
            "displayName": "Approval Actions",
            "iconClass": "fa-pencil",
            "view": "HeadlightPaneStatus",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('Status')"
        },
        {
            "location": "left",
            "name": "solver",
            "displayName": "Solver Logs",
            "iconClass": "fa-calculator",
            "view": "HeadlightPaneSolver"
        },
        {
            "location": "left",
            "name": "validations",
            "displayName": "Validation Logs",
            "iconClass": "fa-exclamation-triangle",
            "view": "HeadlightPaneValidations"
        },
        {
            "location": "right",
            "name": "profile",
            "displayName": "User Profile",
            "iconClass": "fa-user",
            "view": "HeadlightPaneProfile",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('Profile')"
        },
        {
            "location": "right",
            "name": "secret",
            "displayName": "Secrets",
            "iconClass": "fa-person-to-portal",
            "view": "HeadlightPaneSecret"
        },
        {
            "location": "left",
            "name": "bridges",
            "displayName": "Bridges",
            "iconClass": "fa-bridge",
            "view": "HeadlightPaneBridges"
        },
        {
            "location": "left",
            "name": "observations",
            "displayName": "Observations",
            "iconClass": "fa-images",
            "view": "HeadlightPaneObservations",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('Observations')"
        },
        {
            "location": "right",
            "name": "observationdetails",
            "displayName": "Observation Details",
            "iconClass": "fa-image",
            "view": "ObservationDetails"
        },
        {
            "location": "left",
            "name": "observationannotation",
            "displayName": "Observation Annotation",
            "iconClass": "fa-image",
            "view": "ObservationAnnotation"
        },
        {
            "location": "left",
            "name": "observationsubimageselector",
            "displayName": "Create Note",
            "iconClass": "fa-sticky-note",
            "view": "ObservationSubImageSelector"
        },
        {
            "location": "left",
            "name": "testinstancewizard",
            "displayName": "Add Test",
            "iconClass": "fa-flask-vial",
            "view": "TestInstanceWizard"
        },
        {
            "location": "left",
            "name": "qrpanel",
            "displayName": "Scanning",
            "iconClass": "fa-qrcode",
            "view": "QRPanel",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('QRPanel')"
        },
        {
            "location": "right",
            "name": "pictsectionopenseadragonannotationselector",
            "displayName": "Annotation Comments",
            "iconClass": "fa-comments",
            "view": "PictSectionOpenSeaDragonAnnotationSelector"
        },
        {
            "location": "right",
            "name": "academyview",
            "displayName": "Academy",
            "iconClass": "fa-graduation-cap",
            "view": "AcademyView"
        },
        {
            "location": "left",
            "name": "documents",
            "displayName": "Documents",
            "iconClass": "fa-files",
            "view": "HeadlightPaneDocuments",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('Documents')"
        },
        {
            "location": "left",
            "name": "documentdetails",
            "displayName": "Document Details",
            "iconClass": "fa-documents",
            "view": "DocumentDetails"
        },
        {
            "location": "left",
            "name": "inspection",
            "displayName": "Inspection",
            "iconClass": "fa-building-magnifying-glass",
            "view": "Inspection",
            "navigationHandler": "_Pict.views.HeadlightPaneNavigation.handleInspectionPanelToggle(event)"
        },
        {
            "location": "left",
            "name": "samples",
            "displayName": "Samples",
            "iconClass": "fa-vial",
            "view": "HeadlightPaneSamples",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('Samples')"
        },
        {
            "location": "right",
            "name": "sampledetails",
            "displayName": "Sample Details",
            "iconClass": "fa-vial",
            "view": "SampleDetails",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('SampleDetails')"
        },
        {
            "location": "right",
            "name": "projectfilesearch",
            "displayName": "Project Files",
            "iconClass": "fa-files",
            "view": "ProjectFileSearch",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('ProjectFileSearch')"
        },
        {
            "location": "right",
            "name": "comments",
            "displayName": "Comments",
            "iconClass": "fa-comment",
            "view": "CommentCurrent",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('Comments')"
        }
        
    ],
    "CurrentStatus": {
        "status": "Draft",
        "statusClass": "has-text-text-75",
        "statusIcon": "fa-pencil"
    },
    "PanelLocations": {
        "left": { 
            "name": "left",
            "displayName": "Left",
            "animateIn": "animate__slideInLeft", 
            "animateOut": "animate__slideOutLeft", 
            "animateDuration": 500 
        },
        "right": { 
            "name": "right",
            "displayName": "Right",
            "animateIn": "animate__slideInRight", 
            "animateOut": "animate__slideOutRight", 
            "animateDuration": 500 
        }
    },
    "PanelOptions": {
        "LeftyMode": false,
        "Context": "",
        "HelpText": true
    }
}
